import textarea from '@ramsey-design-system/textarea/1/dist/scripts/textarea';
import documentReady from '../../utils/documentReady';

documentReady(() => {
  const textareaNodeList = document.querySelectorAll('.rds-Textarea_1');

  textareaNodeList.forEach(textarea);
});
